import { render, staticRenderFns } from "./ComboTreeMenu.vue?vue&type=template&id=24530387&"
import script from "./ComboTreeMenu.vue?vue&type=script&lang=js&"
export * from "./ComboTreeMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports